import { render, staticRenderFns } from "./RsaSchedaInfermieristicaValutazioneDermatologicaEditComponent.vue?vue&type=template&id=1c7b55fc"
import script from "./RsaSchedaInfermieristicaValutazioneDermatologicaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaInfermieristicaValutazioneDermatologicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports